import React, { useState, Context, ReactElement, Component } from "react";
import { workspaces_type_item } from "./workspaces";
import { namespaces_type_item } from "./namespaces";
import { workload_type_item } from "./workloads";
import { ingress_type_item, rule_type_item } from "./ingress";
// import { datacenter } from "./datacenters";

export interface item extends workload_type_item {
    name?: string;
    key?: string,
    uid?: string;
    cpu?: { usedCPU?: string, requestCPU?: string, limitCPU?: string, totalCPU?: string };
    memory?: { usedMemory?: string, requestMemory?: string, limitMemory?: string, totalMemory?: string };
    rootfs?: { usedRootfs: string, totalRootfs?: string };
    pod?: { usedPod: string, totalPod?: string };
    gpu?: { usedGPU: string, totalGPU?: string };
    pvc?: { usedDisk: string, totalDisk?: string };
    selfLink?: string;
    resourceVersion?: string;
    apiVersion?: string;
    creationTimestamp?: string;
    creator?: string;
    usedMemory?: string;
    usedCPU?: string;
    usedRootfs?: string;
    limitCPU?: string;
    limitMemory?: string;
    limitsRootfs?: string;
    totalCPU?: string;
    totalMemory?: string;
    totalRootfs?: string;
    totalPod?: string;
    totalDisk?: string;
    updateTime?: string;
    quotaName?: string;
    persistent_volume_claims?: string;
    cronjobs_batch?: string;
    daemonsets_apps?: string;
    deployments_apps?: string;
    ingresses_extensions?: string;
    jobs_batch?: string;
    services?: string;
    statefulsets_apps?: string;
    workspace?: string;
    quotas?: object;
    workspaces?: workspaces_type_item[];
    namespaces?: namespaces_type_item[];
    clusterType?: string;
    create_time?: string;

    // route
    internalDomain?: string;
    externalDomain?: string;
    servicePort?: number;
    serviceName?: string;
    createTime?: string;
    path?: string;
    yaml?: any;
    ingresses?: ingress_type_item[];
    namespace?: string;
    id?: string;
    hostname?: string;
    secretName?: string;
    deleteTimestamp?: string;
    domain?: string;
    annotations?: {
        creator?: string;
    };
    rules?: rule_type_item[];
    loadBalancer?: object;
    paths?: [{
        path: string;
        servicename: string;
        serviceport: string
    }];
    labels?: {
        name?: string;
        user?: string;
        workspace?: string;
        namespacequota?: string;
        datacenter?: string;
        type?: string;
        role?: string;
        autoscale?: string;
        maxquota?: string;
        minquota?: string;
        timeout?: string;
        subscriptionId?: string;
        scaleindefer?: string;
        bindcpunodes?: string;
        bindgpunodes?: string;
    };

    // 微服务
    status?: string | object;
    // pod?: number;
    docker?: string;
    create?: string;
    info?: {
        key: string;
        name: string;
        status: string;
        copy: string;
        runtime: string;
    }[];
    ready_total?: object | string;

    // settings
    class?: string;
    host?: string;
    kind?: string;

    // pods
    ip?: string;

    // nodes
    roles?: string;
    pods?: string;
    ram?: string;

    //service-instances
    application?: string;

    //clusters
    generation?: number;
    totalNamespaces?: string;
    clusteragentStatus?: string;
    agentstatus?:{ status?: string, agentStatus?: string };

    // cluster info
    version?: string;
    node?: string;
    usedPod?: string;
    usedDisk?: string;
    user?: string;
    display?: (string | number)[];

    // workload
    scale?: string;
    restart?: string;
    image?: string;
    containers?: {
        name: string;
        image: string;
        resources: {
            limits: object;
            requests: object;
        };
        restart: string;
    }[];

    // applications
    app_cluster?: string;
    app_namespace?: string;
    rules_title?: string[];

    // pod restart alarm
    log_info?: string | undefined;
    restartLog?: {
        prelog?: string | undefined;
        afterlog?: string | undefined;
    },
    container?: string;
}

const ItemsContext: Context<[item[], React.Dispatch<React.SetStateAction<item[]>>]> = React.createContext<[item[], React.Dispatch<React.SetStateAction<item[]>>]>([[] as unknown as item[], (_value: any) => { }]);

const ItemsProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [items, set_items] = useState([] as unknown as item[]);
    return (
        <ItemsContext.Provider value={[items, set_items]}>
            {props.children}
        </ItemsContext.Provider>
    )
}

export { ItemsContext, ItemsProvider };
